import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-container" }




const __default__ = {
  name: 'NavButtons'
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onPrevious", "onNext"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "scroll-btn scroll-left",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onPrevious')))
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        _createElementVNode("path", {
          d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
          fill: "currentColor"
        })
      ], -1)
    ])),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "nav-divider" }, null, -1)),
    _createElementVNode("button", {
      class: "scroll-btn scroll-right",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onNext')))
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        _createElementVNode("path", {
          d: "M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z",
          fill: "currentColor"
        })
      ], -1)
    ]))
  ]))
}
}

})